import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { withTranslation } from 'react-i18next'

import MissActivity from 'app/components/SVGS/MissActivity'
import ButtonDefault from 'app/components/ButtonDefault'
import { DID, DIDNOT } from 'app/constants/identityActions'
import AddToFavorites from 'app/domains/common/AddToFavorites'
import NoteQuotes from 'app/components/NoteQuotes'
import UniversalPopover from 'app/domains/common/UniversalPopover'

import './style.scss'

const bc = 'user-yesterday-activity'

class UserYesterdayActivity extends Component {
  renderTitle = () => (
    <span className={`${bc}__title-question`}>
      {this.props.t(`Did you complete the previous day's MicroAction?`)} <span className={`${bc}__title-dash`}>- </span>
    </span>
  )

  render() {
    const { t, show, sendYesterdayActivity, proTrackName, activity, previousActivity } = this.props

    const Note = (
      <NoteQuotes
        proQuote={activity.get('proQuote')}
        proQuoteAuthor={activity.get('proQuoteAuthor')}
        description={activity.get('description')}
        activityDay={activity.get('day')}
        proTrackName={proTrackName}
      />
    )

    return (
      show && (
        <div className={`${bc}`}>
          <div className={`${bc}__left-side`}>
            <div className={`${bc}__icon`}>
              <MissActivity />
            </div>
            <div className={`${bc}__title`}>
              <UniversalPopover body={Note}>
                {this.renderTitle()}
                <span className={`${bc}__title-span`}>{activity.get('name')}</span>
              </UniversalPopover>
            </div>
          </div>
          <div className={cn(`${bc}__right-side`, `${bc}__button-wrapper`)}>
            <ButtonDefault primary sm onClick={() => sendYesterdayActivity(DID)}>
              {t('I Did It')}
            </ButtonDefault>
            <ButtonDefault sm onClick={() => sendYesterdayActivity(DIDNOT)}>
              {t(`I Couldn't Do It`)}
            </ButtonDefault>
            <AddToFavorites
              customClass={`${bc}__add-to-favorite`}
              customIconClass={`${bc}__add-to-favorite-icon`}
              isYesterday
              activityId={previousActivity.get('id')}
              highlightFavoriteIcon={previousActivity.get('isFavorite')}
              showText={false}
            />
          </div>
        </div>
      )
    )
  }
}

UserYesterdayActivity.propTypes = {
  isMobile: PropTypes.number,
  showModal: PropTypes.func,
  did: PropTypes.func,
  didIt: PropTypes.func,
  proTrackName: PropTypes.string,
  activity: ImmutablePropTypes.map.isRequired,
  previousActivity: PropTypes.object,
}

export default withTranslation('user')(UserYesterdayActivity)
